import { styled } from "@mui/material/styles";

export const LayoutAreaRoot = styled("div")({
  height: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
});
